import classNames from 'classnames'
import * as React from 'react'
import { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { shortFormatNumber } from '../../util'
import { LineChartTooltipSort } from './types'

type ChartTooltipProps = {
  isActive?: boolean
  activeKey?: string
  payload: Payload<ValueType, NameType>[] | undefined
  isReversed?: boolean
  payloadSort?: keyof typeof LineChartTooltipSort
  valueFormatter?: (data: Payload<ValueType, NameType>) => string
}
export default function ChartTooltip({
  isActive,
  activeKey,
  payload,
  payloadSort = 'default',
  isReversed = false,
  valueFormatter,
}: ChartTooltipProps) {
  const items = React.useMemo(() => {
    if (!isActive || !payload || payload.length === 0) return []

    if (LineChartTooltipSort[payloadSort] === LineChartTooltipSort.value) {
      return [...payload].sort((a, b) => Number(b.value ?? 0) - Number(a.value ?? 0))
    }
    return isReversed ? [...payload].reverse() : payload
  }, [payload, payloadSort, isReversed, isActive])

  if (items.length === 0) return null

  return (
    <div className="relative -top-8 space-y-1.5 rounded-md border border-secondary bg-primary p-2.5 font-sans text-2xs leading-4 text-muted-2">
      {items.map((data, index) => {
        if (!data.value) return null

        const label = data.name
        const value = valueFormatter ? valueFormatter(data) : shortFormatNumber(+data.value)

        return (
          <div
            key={index}
            className={classNames('flex items-center justify-between space-x-2.5', {
              'text-default font-medium': data.dataKey === activeKey,
            })}
          >
            <span className="flex min-w-56 items-center space-x-1.5">
              <span className="block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: data.color }}></span>
              <span className="label-with-bold-weight" data-text={label}>
                {label}
              </span>
            </span>
            <span className="label-with-bold-weight w-14 text-right tabular-nums">{value}</span>
          </div>
        )
      })}
    </div>
  )
}
